
import {mapGetters, mapMutations} from "vuex";
import AOS from "aos";

export default {
	computed: {
		...mapGetters({
			offer: 'catalog/catalog-cars/offer'
		}),
		slidesPerView(){
			if(this.$device.isMobile){
				return 1.1
			} else{
				return 2
			}
		},
		centeredSlides(){
			return this.$device.isMobile;
		},
		slidesSpaceBetween(){
			if(this.$device.isMobile){
				return 8
			} else{
				return 24
			}
		}
	},
	methods:{
		...mapMutations({
			setOffer: 'catalog/catalog-cars/SET_OFFER',
			setCarPageLoaded:'catalog/catalog-cars/SET_CAR_PAGE_LOADED',
		})
	},
	destroyed() {
		this.setOffer(null)
	},
	mounted() {
		new swiper.default('.car__slider .swiper', {
			modules: [swiper.Navigation, swiper.Pagination, swiper.Autoplay],
			loop: true,
			
			autoplayDisableOnInteraction: false,
			autoplay: false,
			slidesPerView: this.slidesPerView,
			centeredSlides: this.centeredSlides,
			watchSlidesProgress: true,
			spaceBetween: this.slidesSpaceBetween,
			breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
      spaceBetween: 16
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 3,
      spaceBetween: 16
    }
},
      pagination: {
				el: '.swiper-pagination',
				clickable: 'true',
				type: 'bullets',
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + '<span class="swiper-pagination-bar"></span>' + '<span class="swiper-pagination-progress"></span>' + '</span>';
				},
			},
			navigation: {
				nextEl: '.car__slider .swiper-button-next',
				prevEl: '.car__slider .swiper-button-prev',
			},
			on: {
				init:()=> {
					this.setCarPageLoaded(true)
				},
			},
			
		})
		AOS.init({
			once: true
		})
	}

}
